import Targeting from './targeting'

export default Targeting
